export default __webpack_public_path__ + "static/media/disabled.1390d8e3.svg";